import connector from './blueconicConnector';

window.app = window.app || {};
window.app.blueconic = window.app.blueconic || {};
window.app.blueconic.Connector = new connector(window.blueConicClient);